export default __webpack_public_path__ + "static/media/bg@2x.a15a2748.webp";